import { iamConstants } from './iam.constant';

export function conversationTitle(conversationParticipants, convId) {
    const names = conversationParticipants
        .filter(p => p && p.name)
        .map(p => p.name);

    if (names.length === 0) {
        return convId === iamConstants.DRAFT_CHAT_ID ? iamConstants.DEFAULT_CONVERSATION_TITLE : iamConstants.PARTICIPANT_LEFT_TITLE;
    } else if (names.length === 1) return names[0];

    names[names.length - 1] = `and ${names[names.length - 1]}`;

    return names.length > 2 ? names.join(', ') : names.join(' ');
}

export function isValidConversationId(conversationId) {
    return conversationId && conversationId[0] === '!';
}

export function createMatrixUserId(localPart) {
    return `@${localPart}:ypo`;
}

export function matrixUserIdLocalPart(matrixUserId) {
    const match = /^@(.+):.+?$/.exec(matrixUserId);
    return match && match[1];
}

export const isGroupConversation = (conversation) => {
    let result = false;
    if (conversation && conversation.name) {
        let participants = [];
        if (!conversation.room || Object.keys(conversation.participants).length === Object.keys(conversation.room.currentState.members).length) {
            participants = Object.keys(conversation.participants);
        } else {
            Object.keys(conversation.room.currentState.members || {}).forEach((member) => {
                if (member) {
                    participants.push(matrixUserIdLocalPart(member));
                }
            });
        }
        const itemFound =
            participants.find(key => conversation.name.includes(key));
        if (!itemFound) {
            result = true;
        }
    }
    return result;
};

export const canEditConversation = (conversation) => {
    let result = false;
    if (conversation && conversation.room) {
        const member = conversation.room.currentState.members[conversation.room.myUserId];

        if (member) {
            result = member.powerLevel === iamConstants.powerLevel.MAX;
        }
    }
    return result;
};

export const getMessagesFromConversation = (conversation) => {
    return conversation && conversation.events && conversation.events.length
        ? conversation.events.filter(evt => evt.type === 'message')
        : null;
};

export const getLastReadMessageId = (convo) => {
    let lastReadEventId = null;
    if (convo && convo.room && convo.room.accountData.hasOwnProperty('m.fully_read')) {
        lastReadEventId = convo.room.accountData['m.fully_read'].event.content.event_id;
    }
    return lastReadEventId;
};

export const unReadMessages = (convo) => {
    let result = [];
    const totalMessages = getMessagesFromConversation(convo);
    const lastReadMsgId = getLastReadMessageId(convo);

    if (totalMessages && totalMessages.length) {
       if (!lastReadMsgId) {
           result = [...totalMessages];
       } else {
           const lastReadMessage = totalMessages.find(msg => msg.id === lastReadMsgId);
           if (lastReadMessage) {
               const lastMsgIndx = totalMessages.indexOf(lastReadMessage);
              result = totalMessages.splice(lastMsgIndx + 1);
           }
       }
    }

    return result;
};

export const chatParticipantOneOnOne = (conversation, messengerUsername) => {
    let oneOnOneChatParticipant = null;
    if (conversation && conversation.participants && messengerUsername) {
        const participant = Object.keys(conversation.participants)
            .find(pct => pct !== messengerUsername);
        oneOnOneChatParticipant = conversation.participants[participant];
    }
    return oneOnOneChatParticipant;
};
